import { Flex, Text, CustomButton } from '@/components';

//Redux
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import modalImageFromLanding from '@/assets/modal-image-from-landing.png';

const ModalWrapper = styled(Flex)`
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  align-items: center; 
  text-align: center;
  flex-direction: row; 
  justify-content: center; 
  padding: 20px;
  background: white;
`;

const ImageContainer = styled.div`
  width: 100%; 
  display: flex;
  justify-content: center;
  margin-bottom: 10px; 
`;

const StyledImage = styled.img`
  width: 120px; 
  height: auto;
  margin-right: 20px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
`;

const StyledButton = styled(CustomButton)`
  padding: 22px 40px; 
  margin-top: 20px; 
  width: auto; 
  justify-content: center;
  align-items: center;
`;

const ModalInfoLandingPayment = ({ closeModal }) => {
  const { primaryColor } = useSelector(({ theme }) => theme);

  return (
    <ModalWrapper direction="column" gap="20px" pd="20px" bg="white">
      <ImageContainer>
        <StyledImage src={modalImageFromLanding} alt="Modal from Landing" />
      </ImageContainer>
      <ContentWrapper>
      <Text
        color="#333"
        clave="Estas a 1 paso de usar tu firma como nunca antes! Regístrate y/o inicia sesión para poder asignar tu cuenta a Advance."
        margin="0"
        textAlign="center"
      />
      <Flex justify="center">
        <StyledButton
          bg={primaryColor}
          w="fit-content"
          mt="20px"
          action={() => closeModal()}
        >
          <Flex style={{ cursor: 'pointer' }}>
            <Text clave="accept" />
          </Flex>
        </StyledButton>
      </Flex>
      </ContentWrapper>
    </ModalWrapper>
  );
};
export default ModalInfoLandingPayment;
